import { createContext } from 'react'
import { TCampaignsContext } from './types'

export const CampaignsContext = createContext<TCampaignsContext>({

})